import { useAsyncExecutor2 } from "async-executor-hook";
import { differenceInDays, format } from "date-fns";
import { stringify } from "query-string";
import { useHistory } from "react-router-dom";
import {
  FormControl,
  FormGroup,
  useFormConfig,
  WForm,
  WFormControl,
} from "rectangular-forms";
import { of } from "rxjs";

import { Authorization } from "../../../common/AuthorizationCpt";
import {
  WCalendar,
  WInputText,
  WMultipleTagInput,
  WMultiSelect,
} from "../../../common/components/TemplateContainer/InputTemplates";
import { SaveButton } from "../../../common/components/TemplateContainer/SaveButton";
import { TemplateInputContainer } from "../../../common/components/TemplateContainer/TemplateContainer";
import { removeNullProps } from "../../../common/utils";
import IconVectorRightBlue from "../../../images/icon_button_users_blue.svg";
import { HTTP_METHODS } from "../../../utils/constants";
import { networkBackendRequest } from "../../../utils/networkUtils";
import { SearchBar } from "../../Payment/FilterStyles";
import { ITurnTrackingParams$ } from "../TurnTracking.interface";

export const TurnTrackingSearch = (props: ITurnTrackingParams$) => {
  const { params$ } = props;

  const history = useHistory();

  const loadAppointmentStatuses = useAsyncExecutor2(
    () => {
      return networkBackendRequest(
        "/appointments/turn-status/",
        HTTP_METHODS.GET
      ).then((resp) => resp.json());
    },
    {
      params$: of({}),
    }
  );

  const formConfig = useFormConfig({
    createForm: (data) => {
      const form = new FormGroup({
        customs_dispatcher_name: new FormControl(),
        volante_nums: new FormControl(),
        withdrawal_from_date: new FormControl(),
        withdrawal_to_date: new FormControl(),
        turn_status_option: new FormControl(),
      });
      form
        .get("withdrawal_from_date")
        .valueChanges.subscribe((withdrawal_from_date: Date) => {
          const withdrawalToDate =
            new Date(form.get("withdrawal_to_date").value) || new Date();
          const withdrawalDiffDate = differenceInDays(
            withdrawalToDate,
            new Date(withdrawal_from_date)
          );
          if (withdrawalDiffDate < 1) {
            form.get("withdrawal_to_date").setValue(withdrawal_from_date);
          }
        });
      form.patchValue(data);
      return form;
    },
    onSubmit: (form) => {
      const data = form.value;
      const withdrawal_from_date =
        data.withdrawal_from_date &&
        format(data.withdrawal_from_date, "yyyy-MM-dd");
      const withdrawal_to_date =
        data.withdrawal_to_date &&
        format(data.withdrawal_to_date, "yyyy-MM-dd");
      const pathname = history.location.pathname;
      history.push(
        `${pathname}?${stringify(
          removeNullProps({ ...data, withdrawal_from_date, withdrawal_to_date })
        )}`
      );
    },
  });

  useAsyncExecutor2((params) => params, {
    params$,
    onSuccess: (params) => {
      formConfig.loadSucceed(params);
    },
  });

  const turn_status_option_length =
    formConfig?.form?.value?.turn_status_option?.length;

  return (
    <SearchBar flexStart={false}>
      <Authorization actions={["appointment.get_appointments"]}>
        <WForm formConfig={formConfig} style={{ width: "100%" }}>
          <div
            className="p-grid"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <div className="p-col-6 p-md-3">
              <WFormControl name="customs_dispatcher_name">
                <TemplateInputContainer label="Despachador:">
                  <WInputText
                    width="100%"
                    placeholder="Nombre del importador"
                  />
                </TemplateInputContainer>
              </WFormControl>
            </div>

            <div className="p-col-6 p-md-3">
              <WFormControl name="volante_nums">
                <TemplateInputContainer label="Volantes:">
                  <WMultipleTagInput />
                </TemplateInputContainer>
              </WFormControl>
            </div>
            <div
              className="p-col-12 p-md-6"
              style={{
                width: `${turn_status_option_length > 6 ? "40rem" : ""}`,
              }}
            >
              <WFormControl name="turn_status_option">
                <TemplateInputContainer
                  label="Estado de Turno:"
                  loadStatus={loadAppointmentStatuses.status}
                >
                  <WMultiSelect
                    options={
                      loadAppointmentStatuses.data?.turn_status_option || []
                    }
                    width="100%"
                    optionValue="option"
                  />
                </TemplateInputContainer>
              </WFormControl>
            </div>
          </div>

          <div
            className="p-grid"
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "1rem",
            }}
          >
            <div className="p-col-6 p-md-2">
              <WFormControl name="withdrawal_from_date">
                <TemplateInputContainer label="Periodo desde:" color="#08082B">
                  <WCalendar width="100%" dateFormat="dd/mm/yy" />
                </TemplateInputContainer>
              </WFormControl>
            </div>
            <div className="p-col-6 p-md-2">
              <WFormControl name="withdrawal_to_date">
                <TemplateInputContainer label="Periodo hasta:">
                  <WCalendar
                    width="100%"
                    minDate={
                      formConfig.form?.get("withdrawal_from_date")?.value ||
                      new Date()
                    }
                    dateFormat="dd/mm/yy"
                  />
                </TemplateInputContainer>
              </WFormControl>
            </div>
            <div
              className="p-col-6 p-md-3"
              style={{
                display: "flex",
                alignItems: "flex-end",
              }}
            >
              <SaveButton
                label="Aplicar filtros"
                width="100%"
                height="5rem"
                backgroundColor="#002E6C"
                iconRight={IconVectorRightBlue}
              />
            </div>
            <div className="p-md-5" />
          </div>
        </WForm>
      </Authorization>
    </SearchBar>
  );
};
